<template>
    <div>
        {{time}}
    </div>
</template>

<script>
    export default {
        name: "DummyClock",
        data() {
            return {
                time: ''
            }
        },

        methods: {
            debug(data) {
                console.log(data);
            },
        },

        beforeCreate() {

        },
        created() {
            window.Echo.channel('clock')
                .listen('ClockUpdated', e => {
                    console.log('Clock');
                    console.log(e.clock.time);
                    this.time = e.clock.time;
                });
        },


    };
</script>

<style scoped>

</style>